// Exact copy except import UserService from shared
import { Component, OnInit }      from "@angular/core";

@Component({
  template: require("./lostCredentials.confirmation.html"),
  styles: [require("./lostCredentials.component.less").toString()]
})
export class LostCredentialsConfirmation {
  message: string;

  constructor() {
    this.message = "your password has been reset!";
  }
}




// WEBPACK FOOTER //
// ./src/app/modules/lostCredentials/lostCredentials.confirmation.ts